import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'alert-dialog',
    template: `
        <p>{{ data.message }}</p>
        <button type="button" mat-raised-button 
            (click)="dialogRef.close(true)">OK</button>
    `,
})
export class AlertDialog {

    public title: string;
    public message: string;

    
    constructor(
    public dialogRef: MatDialogRef<AlertDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
}